<template>
  <div>
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ getTitle }}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <router-link :to="routeToCreation">
              <a class="button is-addOrEdit"
                 :class="{'button-access-no-permission' : !checkPermissions(permCatalogue.maj)}">
                {{ $t('catalogue.button.newProduct') }}
              </a>
            </router-link>
          </div>
        </div>
      </div>
      <div class="tab is-marginless">
        <ul>
          <li :class="{'is-active': activeTab === 'catalogue-produits'}"
              @click="updateActiveTab('catalogue-produits')">
            {{ $t('catalogue.tab.products') }}
          </li>
          <li :class="{'is-active': activeTab === 'catalogue-produits-non-com'}"
              @click="updateActiveTab('catalogue-produits-non-com')">
            {{ $t('catalogue.tab.unavailable') }}
          </li>
        </ul>
      </div>
      <div>
      </div>
    </div>
    <div>
      <component :is="activeTab" />
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import * as devisConf from '@/configuration/devisConf';
import AppBreadcrumb from '@/components/general/breadcrumb';
import CatalogueProduits from '@/components/catalogue/l_catalogueProduits';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import { PRODUITS_PRESSE_INFOS } from '@/configuration/catalogue/produitConf';
import catalogueProduitsNonCom from '@/components/catalogue/l_catalogueProduitsNonCom';

const permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      activeTab: 'catalogue-produits',
      isComponentSupprimerDevis: false,
      critereRecherche: {},
      etatsSelected: [],
      rechercheAvancee: false,
      devisSelectionne: false,
      selectAllValue: false,
      isSelectOnly: false,
      devisASupp: [],
      type: devisConf.TYPE_DEVIS,
      permCatalogue: CATALOGUE,
    };
  },
  components: {
    CatalogueProduits,
    AppBreadcrumb,
    catalogueProduitsNonCom,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeCommandes.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.getTitle, route: { name: 'l.bodac.catalogue' }, isActive: true },
      ];
      return output;
    },
    getTitle() {
      switch (this.activeTab) {
        case 'catalogue-produits':
          return this.$i18n.t('catalogue.titleProduit');
        default:
          return this.$i18n.t('catalogue.titleProduitNonCom');
      }
    },
    routeToCreation() {
      if (this.$route.params.typeProduit
      && !!PRODUITS_PRESSE_INFOS[this.$route.params.typeProduit]) {
        return { name: PRODUITS_PRESSE_INFOS[this.$route.params.typeProduit].routeCreation };
      }
      return { name: 'm.bodac.catalogue-typeCreation' };
    },
  },
  methods: {
    updateActiveTab(activeTab) {
      this.activeTab = activeTab;
      switch (activeTab) {
        case 'catalogue-produits':
          this.setInformationPage(this.$t('pageGescom.produit.listeProduit'));
          break;
        default:
          this.setInformationPage(this.$t('pageGescom.produit.listeProduitNonCom'));
      }
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pageGescom.produit.listeProduit'));
  },
};
</script>
